import { useState, useEffect, useRef } from "react";
import { getAttachments, uploadAttachment, deleteAttachment } from "../../mailerApi";
import "./Mailer.css";

function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function formatDate(s) {
  if (!s) return "";
  try {
    return new Date(s).toLocaleDateString("ka-GE");
  } catch {
    return "";
  }
}

export default function AttachmentsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const d = await getAttachments();
      setItems(Array.isArray(d) ? d : (d.results || []));
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }

  async function handleUpload(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError("");
    try {
      const att = await uploadAttachment(file, file.name);
      setItems(prev => [att, ...prev]);
    } catch (err) {
      setError(err.message);
    }
    setUploading(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }

  async function handleDelete(item) {
    if (!window.confirm(`წავშალო "${item.name}"?`)) return;
    try {
      await deleteAttachment(item.id);
      setItems(prev => prev.filter(i => i.id !== item.id));
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="mailer-page library-page">
      <div className="mailer-header">
        <h1>ფაილები</h1>
        <div className="library-toolbar">
          <input
            ref={fileInputRef}
            type="file"
            style={{ display: "none" }}
            onChange={handleUpload}
          />
          <button
            className="btn btn-primary"
            onClick={() => fileInputRef.current?.click()}
            disabled={uploading}
          >
            {uploading ? "იტვირთება..." : "+ ფაილის ატვირთვა"}
          </button>
        </div>
      </div>

      {error && <div className="mailer-error">{error}<button onClick={() => setError("")}>×</button></div>}

      {loading ? (
        <div className="library-empty">იტვირთება...</div>
      ) : items.length === 0 ? (
        <div className="library-empty">
          ბიბლიოთეკა ცარიელია — ატვირთე PDF ან სხვა ფაილი, შემდეგ მიამაგრე გაგზავნისას.
        </div>
      ) : (
        <div className="library-grid">
          {items.map(item => (
            <div key={item.id} className="library-card">
              <div className="library-card-icon">PDF</div>
              <div className="library-card-name" title={item.name}>{item.name}</div>
              <div className="library-card-meta">
                {formatSize(item.size_bytes)} · {formatDate(item.created_at)}
              </div>
              <div className="library-card-actions">
                {item.file_url && (
                  <a className="btn btn-sm" href={item.file_url} target="_blank" rel="noreferrer">
                    გახსნა
                  </a>
                )}
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item)}>
                  წაშლა
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
